export default __webpack_public_path__ + "static/media/educators5.32d70d98.jpg";